<template>
    <div>
        <v-text-field
          readonly
          v-model="diff.new"
          outlined
          hide-details
          :class="getInputClass(diff)"
        >
        </v-text-field>
        <div class="d-flex mt-2" v-if="diff.old !== null">
                        <span class="mr-2" :style="'color:' + updateColors.deep"
                              v-if="diff.new !== null">
                            Avant:
                        </span>
            <span class="mr-2" :style="'color:' + deleteColors.deep" v-else>Supprimé:</span>
            <span class="px-2 rounded" v-if="diff.new !== null"
                  :style="'background-color:' + updateColors.deep + '; color:' + updateColors.light">
                            {{ diff.old }}
                        </span>
            <span class="px-2 rounded" v-else
                  :style="'background-color:' + deleteColors.deep + '; color:' + deleteColors.light">
                            {{ diff.old }}
                        </span>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex"

export default {
    name: "TextFieldDiffs",
    props: ["diff"],
    methods: {
        getInputClass(diff) {
            if (diff.new !== null && diff.old === null) {
                return "input-add"
            } else if (diff.new !== null && diff.old !== null) {
                return "input-update"
            } else if (diff.new === null && diff.old !== null) {
                return "input-error"
            }
        },
    },
    computed: {
        ...mapState("sitAnswer", [
            "addColors",
            "updateColors",
            "deleteColors",
        ]),
    },
}
</script>